import React from 'react';
import PropTypes from 'prop-types';

import { capitaliseFirstChar, classNames } from '../../utilities';
import { adminMenuChildPropTypes } from '../AdminMenu/admin-menu-prop-types';

import styles from './Menu.css';

export const MenuList = ({
  handleMenuToggle,
  handleSubNavToggle,
  isNotInView,
  item,
  menuOrder
}) => (
  <li className={classNames(styles.menuListItem, isNotInView && styles.isNotInView)}>
    {item.items ? (
      <button
        className={classNames(
          styles.menuListItemButton,
          styles[`menuIcon${capitaliseFirstChar(item.icon)}`]
        )}
        onClick={() => handleSubNavToggle(item.title)}
        type="button">
        {item.title}
      </button>
    ) : (
      <a
        className={classNames(
          styles.menuListItemLink,
          styles[`menuIcon${capitaliseFirstChar(item.icon)}`]
        )}
        href={item.url}
        onClick={handleMenuToggle}>
        {item.title}
      </a>
    )}
    {item.items && (
      <ul
        className={classNames(
          styles.menuListItemSubNav,
          menuOrder.indexOf(item.title) !== -1 && styles.isShown
        )}>
        {item.items.map(subItem => (
          <MenuList
            handleMenuToggle={handleMenuToggle}
            handleSubNavToggle={() => handleSubNavToggle(subItem.title)}
            isNotInView={menuOrder.indexOf(item.title) !== menuOrder.length - 1}
            item={subItem}
            key={subItem.title}
            menuOrder={menuOrder}
          />
        ))}
      </ul>
    )}
  </li>
);

MenuList.propTypes = {
  handleMenuToggle: PropTypes.func.isRequired,
  handleSubNavToggle: PropTypes.func.isRequired,
  isNotInView: PropTypes.bool,
  // eslint-disable-next-line react/require-default-props, react/no-typos
  item: adminMenuChildPropTypes.item,
  menuOrder: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired
};

MenuList.defaultProps = {
  isNotInView: false
};
